<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    class="heroicon-launch heroicon heroicon-sm"
  >
    <path
      class="heroicon-launch-ship heroicon-component-fill"
      fill="#FFFFFF"
      d="M22 23c0-3.31 1.9-7.9 4.24-10.24l2.05-2.05c.4-.4 1.15-.71 1.71-.71.55 0 1.32.32 1.71.71l2.05 2.05C36.1 15.1 38 19.68 38 23V53H22V23z"
    ></path>
    <path
      class="heroicon-launch-ship-wings heroicon-component-fill"
      fill="#FFFFFF"
      d="M23 25v28H9v-5l10-10V28l4-3zm14 0l4 4v9l10 10v5H37V25z"
    ></path>
    <path
      class="heroicon-launch-rocket-tank heroicon-component-fill"
      fill="#FFFFFF"
      d="M38 25l3 3V14l-2-5-7.58-7.58a2 2 0 0 0-2.84 0L21 9l-2 5v14l3-3v-2c0-3.31 1.9-7.9 4.24-10.24l2.05-2.05c.4-.4 1.15-.71 1.71-.71.55 0 1.32.32 1.71.71l2.05 2.05C36.1 15.1 38 19.68 38 23V25z"
    ></path>
    <path
      class="heroicon-launch-boosters heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M45.26 14.1A12.05 12.05 0 0 1 48 21v24l-6-6V21a12.08 12.08 0 0 1 2.74-6.9A2 2 0 0 1 45 14l.26.1zM11 53h8v6h-8v-6zm30 0h8v6h-8v-6zM15 14l.26.1A12.05 12.05 0 0 1 18 21v18l-6 6V21a12.08 12.08 0 0 1 2.74-6.9A2 2 0 0 1 15 14zm8 39h6v3h-6v-3zm8 0h6v3h-6v-3z"
    ></path>
    <polygon
      class="heroicon-launch-ship-stabilizer heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      points="29 55 31 55 31 46.41 30 45.41 29 46.41"
    ></polygon>
    <path
      class="heroicon-shadows"
      fill="#000000"
      d="M20 23c0-3.31 2.12-7.65 4.74-9.68l3.48-2.71c.43-.34 1.22-.61 1.78-.61.55 0 1.35.27 1.78.6l3.48 2.72C37.88 15.35 40 19.68 40 23V53H20V23zm2 0v30h16V23c0-3.32-1.9-7.9-4.24-10.24L31.7 10.7c-.4-.4-1.16-.71-1.71-.71-.56 0-1.32.32-1.71.71l-2.05 2.05C23.9 15.1 22 19.69 22 23zM11 53h8v6h-8v-6zm30 0h8v6h-8v-6zm-18 0h6v3h-6v-3zm8 0h6v3h-6v-3z"
      opacity=".2"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M22.24 6.76L28.3.7C28.68.32 29.44 0 30 0c.55 0 1.32.32 1.7.7l6.06 6.06c1.87 1.87 3.46 5.18 4.02 8.12.45-.82.97-1.57 1.52-2.17l.27-.23A2.8 2.8 0 0 1 45 12c.44 0 1.02.2 1.43.48l.27.23a14 14 0 0 1 3.3 8.3V46l.59.59c.78.78 1.41 2.3 1.41 3.4V54h-2v6H40v-6h-2v3H22v-3h-2v6H10v-6H8v-4c0-1.1.63-2.63 1.41-3.41L10 46V21a14 14 0 0 1 3.3-8.29l.27-.23A2.8 2.8 0 0 1 15 12c.44 0 1.02.2 1.43.48l.27.23c.55.6 1.07 1.35 1.52 2.17.56-2.95 2.15-6.25 4.02-8.12zM35.17 54H32v1h4v-.17l-.83-.83zM28 55v-1h-3.17l-.83.83V55h4zm0-3v-1h-4v1h4zm0-2v-4l1.3-1.3.7-.7.7.7L32 46v4h4V25H24v25h4zm4 1v1h4v-1h-4zM16 40h-4v4l4-4zm2-4v-2h-6v5h4.94c.63-.88 1-1.92 1.06-3zm0-6v-2h-6v5h6v-3zm4-6v-1c0-3.31 1.9-7.9 4.24-10.24l2.05-2.05c.4-.4 1.15-.71 1.71-.71.55 0 1.32.32 1.71.71l2.05 2.05C36.1 15.1 38 19.69 38 23v1l2 2v-9c0-2.44-1.3-5.87-2.94-8H22.94C21.3 11.13 20 14.57 20 17v9l2-2zM36.17 8L30.3 2.12 30 2c-.02 0-.28.1-.3.12L23.84 8h12.34-.01zM42 33h6v-5h-6v5zm0 3c0 .94.45 2.17 1.06 3H48v-5h-6v2zm6 8v-4h-4l4 4zM12 55h6v-1h-6v1zm0 2.83V58h6v-.17l-.83-.83h-4.34l-.83.83zM22 52v-1H10v1h12zm0-5h-5v3h5v-3zm0-20.17L20.83 28c-.4.4-.83 1.42-.83 2v6a7.5 7.5 0 0 1-2 4.83L10.83 48c-.4.4-.83 1.43-.83 2h6v-4h6V26.83zm16 0V46h6v4h6c0-.57-.42-1.6-.83-2L42 40.83A7.49 7.49 0 0 1 40 36v-6c0-.58-.42-1.6-.83-2L38 26.83zM38 50h5v-3h-5v3zm0 2h12v-1H38v1zm-2-29c0-2.78-1.69-6.86-3.66-8.83l-2.04-2.05L30 12c-.02 0-.28.1-.3.12l-2.04 2.05C25.69 16.14 24 20.22 24 23.01V24h12v-1zm6 32h6v-1h-6v1zm0 2.83V58h6v-.17l-.83-.83h-4.34l-.83.83zM42 27h6v-5h-6v5zm3.26-12.9L45 14a2 2 0 0 0-.26.1A12.08 12.08 0 0 0 42 21h6c0-2.14-1.25-5.24-2.74-6.9zm-30 0L15 14a2 2 0 0 0-.26.1A12.08 12.08 0 0 0 12 21h6c0-2.14-1.25-5.24-2.74-6.9zM18 27v-5h-6v5h6zm11 28h2v-8.59l-1-1-1 1V55zm3-36h2v2h-3v-2h1zm-6 0h3v2h-3v-2zm3 8h6v16H25V27h4zm2 1v14h3V28h-3zm-2 14V28h-3v14h3z"
    ></path>
  </svg>
</template>
